import { PublicClientApplication } from '@azure/msal-browser';
import { getConfig } from './runtimeConfig.js';

const clientId = getConfig(
  'AZURE_CLIENT_ID',
  import.meta.env.VITE_AZURE_CLIENT_ID,
);
const tenantId = getConfig(
  'AZURE_TENANT_ID',
  import.meta.env.VITE_AZURE_TENANT_ID,
);

export const azureEnabled = Boolean(clientId && tenantId);

let _instance = null;
let _initPromise = null;

function getInstance() {
  if (!_instance) {
    _instance = new PublicClientApplication({
      auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: new URL('.', window.location.href).href,
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
      },
    });
  }
  return _instance;
}

async function init() {
  const inst = getInstance();
  if (!_initPromise) _initPromise = inst.initialize();
  await _initPromise;
  return inst;
}

/**
 * Call once on every app load (before showing any UI).
 * Returns the Azure ID token string if this page load is the result
 * of an Azure redirect, otherwise returns null.
 */
export async function handleAzureRedirect() {
  if (!azureEnabled) return null;
  const inst = await init();
  const result = await inst.handleRedirectPromise();
  return result?.idToken ?? null;
}

/**
 * Starts the Microsoft sign-in flow. The browser navigates away to
 * Microsoft; when authentication completes Microsoft redirects back
 * to the app and handleAzureRedirect() picks up the result.
 */
export async function signInWithAzure() {
  if (!azureEnabled) throw new Error('Azure SSO is not configured');
  const inst = await init();
  // loginRedirect navigates away — no code after this line runs
  await inst.loginRedirect({ scopes: ['openid', 'profile', 'email'] });
}
